import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { LoginService } from '../services/login.service';

/**
 * @author Hamayak Howsepjan (Z0049XYT)
 */
@Injectable({
  providedIn: 'root'
})
export class LoginGuard {

  constructor(
    private userService: UserService,
    private loginService: LoginService) {}


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isLoggedIn();
  }

  // Check if user is logged in
  private isLoggedIn() {
    const user = this.userService.userValue;
    if (!user) {
      return true;
    }
    this.loginService.defaultRedirectURL();
    return false;
  }
}
